import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';

/**
 * 列表
 * 页面：领导审批页
 * 前端：洪芳
 * 后端： 范腾
 * @params {Object} params: demo传参对象
 */
export async function getEditAndCheckList(params) {
  return request(`${url.url}/web/v3/news/approvalList?${stringify(params)}`);
}


/**
 * 获取学校类型
 * 页面：详情页
 * 前端：洪芳
 * 后端： 范腾
 * @params {Object} params: demo传参对象
 */
export async function getOrgType(params) {
  return request(`${url.url}/web/v3/news/getOrgType?${stringify(params)}`);
}


